const riot = require('riot');
import '../components/users.tag'
riot.tag2('page-users', '<users></users>', '', '', function(opts) {
});
